import type { HydratedDocument } from 'mongoose';
import { z } from 'zod';
import { DateSchema, ObjectIdSchema } from './base';
import type { UserDocument } from './user';

export enum FileScope {
  MESSAGE_TEMPLATE = 'message-template',
}

export const StoreFileBodySchema = z.object({
  scope: z.nativeEnum(FileScope),
});

export const StoreFileFromURLBodySchema = z.object({
  url: z.string().url(),
  scope: z.nativeEnum(FileScope),
});

export const FileSchema = z.object({
  id: ObjectIdSchema,
  name: z.string(),
  storageKey: z.string(),
  hash: z.string(),
  scope: z.nativeEnum(FileScope),
  creatorId: ObjectIdSchema.optional(),
  createdAt: DateSchema,
  updatedAt: DateSchema,
});

export type StoredFile = z.infer<typeof FileSchema>;

export interface FileDocumentMethods {
  canEdit(user: UserDocument | Express.User): Promise<boolean>;
  canRead(user: UserDocument | Express.User): Promise<boolean>;
}

export type FileDocument = HydratedDocument<StoredFile, FileDocumentMethods>;
